// TODO: Deprecated Carousel replace with AdaptiveCarousel when i18n ready
/* eslint-disable @vp/swan/no-deprecated */
import { useTranslation } from 'react-i18next';
import { BoundedContent, Carousel, CarouselSlide, H2, P, RatingsStars, Span } from '@vp/swan';

const generateReviewSchema = (items: Array<{ review: string; rating: number; name: string }>) => ({
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: items.map(({ review, rating, name }) => ({
        '@type': 'Review',
        itemReviewed: {
            '@type': 'Organization',
            name: 'VistaPrint',
        },
        reviewRating: {
            '@type': 'Rating',
            ratingValue: rating,
            bestRating: 5,
        },
        reviewBody: review,
        author: {
            '@type': 'Person',
            name,
        },
    })),
});

const Testimonials = () => {
    const { t } = useTranslation();

    const testimonialData = [
        {
            review: '“Couldn’t be happier! Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque feugiat, sapien eget aliquam fringilla, lacus justo”',
            rating: 5,
            name: 'David',
            businessName: 'verified buyer',
        },
        {
            review: "“Couldn't be happier! Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque feugiat, sapien eget aliquam fringilla, lacus justo”",
            rating: 5,
            name: '1797562',
            businessName: 'logo-essential-v8r',
        },
        {
            review: "“Couldn't be happier! Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque feugiat, sapien eget aliquam fringilla, lacus justo”",
            rating: 5,
            name: 'Rachel Burson',
            businessName: 'Rachel Made Studio',
        },
    ];

    const accessibleTextForDots = testimonialData.map((_, index) => `Slide ${index + 1}`);

    return (
        <BoundedContent marginY="between-sections" id="testimonials" as="section">
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify(generateReviewSchema(testimonialData)),
                }}
            />
            <H2 fontSkin="title-section" id="testimonials-heading">
                {t('Logomaker GenAi Landing Page > Testimonials > Title.value')}
            </H2>
            <P>{t('Logomaker GenAi Landing Page > Testimonials > Sub Title.value')}</P>

            <Carousel
                progressIndicator="dots"
                arrows={false}
                aria-labelledby="testimonials-heading"
                aria-roledescription="carousel"
                accessibleTextForDots={accessibleTextForDots}
                accessibleTextForPrevious="Go to previous slide"
                accessibleTextForNext="Go to next slide"
                // TODO: Localize the following strings via i18n keys
                accessibleTextForVisibleSlides="Visible slides"
                accessibleTextForSlide="Slide"
                slidesToShow={{ xs: 1, sm: 3, md: 3, lg: 3, xl: 3 }}
                gridGutters
                as="ul"
            >
                {testimonialData.map(({ review, rating, name, businessName }, index) => (
                    <CarouselSlide
                        key={name || index}
                        paddingRight={2}
                        aria-roledescription="slide"
                        as="li"
                    >
                        <P fontSkin="title-item">{review}</P>
                        <RatingsStars hideRating ratingValue={rating} aria-hidden />
                        <P>
                            <Span fontSkin="body-standard-bold">{name}</Span>
                            <Span fontSkin="body-standard">, {businessName}</Span>
                        </P>
                    </CarouselSlide>
                ))}
            </Carousel>
        </BoundedContent>
    );
};

export default Testimonials;
